import "./style.scss";

import type { PrismicDocument } from "@prismicio/client";
import * as prismic from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import ModalBox from "components/Modal";
import { useTranslation } from "react-i18next";

interface ChangelogModalProps {
    isOpen: boolean;
    changelogMessage: false | PrismicDocument<Record<string, any>, string, string> | undefined;
    onClose: () => void;
    isImportant?: boolean;
}

const ChangelogModal = (props: ChangelogModalProps) => {
    const { isOpen, changelogMessage, onClose, isImportant = true } = props;
    const [t] = useTranslation();

    return (
        <div className="changelog-modal">
            <ModalBox onClose={onClose} open={isOpen} mainTitle={t("NavigationBar.Changelog")}>
                <div className="changelog-container changelog-modal-content">
                    {/* <PrismicRichText field={changelogMessage && changelogMessage.data.title} /> */}
                    <PrismicRichText
                        field={
                            changelogMessage &&
                            (isImportant ? changelogMessage.data.important : changelogMessage.data.content)
                        }
                    />
                </div>
            </ModalBox>
        </div>
    );
};

export default ChangelogModal;
